import { Chip, Tooltip } from "@mui/material";
import { useAuth } from "providers/Auth";
import { isInternalSession } from "providers/Auth/internalSession";
import { useInternalSessionLimit } from "./internalSessionLimit";

/** Marks a session minted from Poseidon so an operator never mistakes it for a customer login. */
export function InternalSessionChip() {
  useInternalSessionLimit();
  const { auth } = useAuth()!;
  if (!isInternalSession(auth?.claims)) return null;
  const claims = (auth?.claims ?? {}) as { actor?: string };
  const label = `Internal session · ${auth.tenant ?? "?"} · ${claims.actor ?? "unknown"}`;
  return (
    <Tooltip title="Opened from Poseidon. The session ends 2 hours after it was opened; open it again from Poseidon.">
      <Chip size="small" color="warning" label={label} sx={{ ml: 1.5, fontWeight: 600 }} />
    </Tooltip>
  );
}
